<template>
  <div id="page-project" class="page">
    <div class="container">
      <section>
        <header class="header">品牌介绍</header>
        <p class="subtitle">Brand introduction</p>
        <div class="logos">
          <img src="/static/project-logo-skeleton.png"/>
          <img src="/static/project-logo.png"/>
          <img src="/static/project-logo-text.png"/>
        </div>
        <div class="row brand-desc">
          <div class="col-sm">
            <p>弦熵科技是国内最早投入人工智能无人货柜研发和量产的品牌之一</p>
            <p>专注于零售场景改造升级的解决方案</p>
            <p>用AI赋能新零售，开辟零售新时空！</p>
          </div>
          <div class="col-sm">
            <p>应用AI、BI、loT、智能硬件等技术在无人零售领域取得了辉煌的成绩：</p>
            <p>1.国内第一台非rfid人工智能售货机</p>
            <p>2.国内第一台动态识别人工智能售货机</p>
            <p>3.国内第一台多维度识别人工智能售货机</p>
          </div>
          <div class="col-sm">
            <p>弦熵科技的三个发展方向：</p>
            <p>1.无人售货机产品升级</p>
            <p>2.新零售消费场景升级</p>
            <p>3.传统零售行业重构</p>
          </div>
          <div class="col-sm">
            <p>目前我们通过人工智能识别技术打破了零售行业的消费边际，实现了零售业全场景、全类目、全时段。</p>
            <p>我们的愿景是应用AI与loT技术重构供给结构、赋能零售行业</p>
          </div>
        </div>
      </section>
      <section>
        <header class="header">团队介绍</header>
        <p class="subtitle">Team introduction</p>
          <div class="team-pics">
          <div class="left">
            <img src="/static/project-team1.png"/>
          </div>
          <div class="middle">
            <img class="top" src="/static/project-team2.png"/>
            <img src="/static/project-team3.png"/>
          </div>
          <div class="right">
            <img src="/static/project-tean4.png"/>
          </div>
        </div>

        <div class="team-desc">
          <p>弦熵的创始团队组建于15年，目前在物联网、人工智能、智能硬件、新零售等领域技术成果颇丰。团队有20余名核心成员曾任职于BAT、美团、华为、东软、赶集、国美、西门子等知名企业。</p>
          <p>值得骄傲的是，创始团队是HTML5开发者社区联合发起者，参与互联网和物联网的国际标准制定。现与北京邮电大学、澳大利亚La Trobe大学建有联合实验室。为北京邮电大学、大连东软信息学院指定为人工智能实践教学基地。</p>
          <p>2018年弦熵科技锁定了新零售领域人工智能底层应用的研发方向。致力于用人工智能为新零售赋能，应用技术创造行业革新。目前弦熵所生产的人工智能售货机X398F-VGB在全球出货量名列前茅，其迅速精准的人工智能商品识别以及高度商业化的运营SOP配套广受客户好评。</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'project',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-project {
  .header {
    margin-top: 60px;
    font-size: 32px;
    color: #333333;
  }
  .subtitle {
    font-size: 14px;
    color: #888888;
  }
  .logos {
    background-color: #f5f5f5;
    padding: 40px;
    img {
      margin: 10px;
    }
  }
  .brand-desc {
    margin-top: 20px;
    text-align: left;
    font-size: 14px;
  }
  .team-pics {
    display: flex;
  }

  .team-pics img {
    max-width: 100%;
    vertical-align: top;
  }

  .team-pics .left{
    flex: 36;
    margin-right: 20px;
  }
  .team-pics .middle{
    flex: 49;
  }
  .team-pics .right{
    margin-left: 20px;
    flex: 36;
  }
  .team-pics .top {
    margin-bottom: 20px;
  }

  .team-desc {
    margin-top: 20px;
    text-align: left;
    font-size: 14px;
    text-indent: 2em;
  }
}
@media only screen and (max-width: 1700px) and (min-width: 0px) {
  .team-pics .middle .top{
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Project.vue